// WYA theme behaviour.
//
// Everything here is progressive enhancement: forms post normally and links
// navigate normally without it. JavaScript only makes those interactions
// smoother. Listeners are delegated from `document` so they survive the cart
// drawer being replaced by the Section Rendering API.
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Translated strings, rendered into the page by the layout.
  var STRINGS = {};
  try {
    var el = document.querySelector('[data-theme-strings]');
    if (el) STRINGS = JSON.parse(el.textContent);
  } catch (err) { STRINGS = {}; }

  /* ---------------------------------------------------------------- utils */

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ------------------------------------------------- announcement rotation */

  var bar = $('[data-announcement]');
  if (bar) {
    var messages = $$('.announcement__item', bar);
    if (messages.length > 1 && !REDUCED) {
      var m = 0;
      setInterval(function () {
        messages[m].hidden = true;
        m = (m + 1) % messages.length;
        messages[m].hidden = false;
      }, 5000);
    }
  }

  /* ------------------------------------------------------ sort auto-submit */

  document.addEventListener('change', function (e) {
    var select = e.target.closest('select[data-auto-submit]');
    if (select && select.form) select.form.submit();
  });

  /* ------------------------------------------------------------ cart drawer */

  function drawer() { return $('[data-cart-drawer]'); }

  // Clearing before setting makes assistive tech re-announce an identical
  // message — otherwise a second "Added to cart" is silent.
  function announce(message) {
    var region = $('[data-cart-status]');
    if (!region) return;
    region.textContent = '';
    setTimeout(function () { region.textContent = message; }, 100);
  }

  function focusable(root) {
    if (!root) return [];
    var sel = 'a[href], button:not([disabled]), input:not([disabled]),' +
              ' select:not([disabled]), [tabindex]:not([tabindex="-1"])';
    return Array.prototype.slice.call(root.querySelectorAll(sel))
      .filter(function (el) { return el.offsetParent !== null; });
  }

  var lastFocused = null;

  function openDrawer() {
    var d = drawer();
    if (!d || d.classList.contains('is-open')) return;

    lastFocused = document.activeElement;
    d.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    var targets = focusable($('.cart-drawer__panel', d));
    if (targets.length) targets[0].focus();
  }

  function closeDrawer() {
    var d = drawer();
    if (!d || !d.classList.contains('is-open')) return;

    d.classList.remove('is-open');
    document.body.style.overflow = '';

    // Return focus to whatever opened the drawer, not to the top of the page.
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    lastFocused = null;
  }

  // Keep Tab inside the drawer while it's open — it's aria-modal, so focus
  // escaping behind it misrepresents the page to screen reader users.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;

    var d = drawer();
    if (!d || !d.classList.contains('is-open')) return;

    var targets = focusable($('.cart-drawer__panel', d));
    if (!targets.length) return;

    var first = targets[0];
    var last = targets[targets.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  // Re-render the drawer from the server so its markup stays in Liquid.
  // `restore` is an optional selector to re-focus afterwards: replacing
  // innerHTML destroys whatever the keyboard user was on.
  function refreshCart(restore) {
    return fetch(window.location.pathname + '?sections=cart-drawer', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;

        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-cart-drawer]');
        var existing = drawer();
        if (!fresh || !existing) return;

        var wasOpen = existing.classList.contains('is-open');
        existing.innerHTML = fresh.innerHTML;
        if (wasOpen) existing.classList.add('is-open');

        // Keep the header badge in step with the drawer.
        var head = existing.querySelector('.cart-drawer__head span');
        if (head) {
          var count = (head.textContent.match(/\d+/) || ['0'])[0];
          $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
        }

        if (restore) {
          var again = existing.querySelector(restore);
          // If the button is now disabled (quantity hit 1), fall back to its
          // sibling so focus doesn't drop to the body.
          if (again && !again.disabled) again.focus();
          else if (again) {
            var sibling = again.parentElement.querySelector('.qty__btn:not(:disabled)');
            if (sibling) sibling.focus();
          }
        }
      })
      .catch(function () { /* fall through to a normal page load */ });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      openDrawer();
      return;
    }

    if (e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(remove.dataset.cartRemove, 10), quantity: 0 })
      })
        .then(refreshCart)
        .then(function () { announce(STRINGS.cartRemoved || 'Item removed from cart.'); })
        .catch(function () { window.location.href = remove.href; });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ------------------------------------- overlay header (story template) */

  // On the story page the hero sits behind a transparent header. Rather than
  // hardcode a header height -- which the rotating announcement bar could change
  // -- measure it into a CSS variable and let the hero pull itself up by that.
  var header = $('.header');

  if (header && document.body.classList.contains('template-suffix-story')) {
    var setOffset = function () {
      // Distance from the top of the document to the bottom of the header,
      // which is exactly how far the hero needs to rise.
      var offset = header.getBoundingClientRect().bottom + window.scrollY;
      document.documentElement.style.setProperty('--header-offset', offset + 'px');
    };

    setOffset();
    window.addEventListener('load', setOffset);
    window.addEventListener('resize', setOffset);

    // Go solid once the header would otherwise sit over lighter parts of the
    // photo. Only touches background and border, so there is no layout shift.
    var solidify = function () {
      header.classList.toggle('is-solid', window.scrollY > 40);
    };

    solidify();
    window.addEventListener('scroll', solidify, { passive: true });
  }

  /* -------------------------------------------- product quantity stepper */

  // The input is a native number field, so it already works without this.
  // These buttons are a nicer target than the browser's spinner arrows.
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;

    var input = step.parentElement.querySelector('.qty__input');
    if (!input) return;

    var min = parseInt(input.min || '1', 10);
    var next = (parseInt(input.value, 10) || min) + parseInt(step.dataset.qtyStep, 10);
    input.value = next < min ? min : next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------ quantity change */

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/change"]');
    if (!form) return;

    // e.submitter tells us which of the two buttons was pressed, and therefore
    // the target quantity — the value lives on the button, not a shared input.
    var button = e.submitter;
    if (!button || button.disabled) return;

    e.preventDefault();

    var line = form.querySelector('input[name="line"]').value;
    var quantity = button.value;
    var restore = '[data-qty-line="' + button.dataset.qtyLine + '"]' +
                  '[data-qty-dir="' + button.dataset.qtyDir + '"]';

    form.setAttribute('aria-busy', 'true');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(quantity, 10) })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('change failed');
        return refreshCart(restore);
      })
      .then(function () {
        announce((STRINGS.quantityUpdated || 'Quantity updated to __QTY__.')
          .replace('__QTY__', quantity));
      })
      .catch(function () {
        form.removeAttribute('aria-busy');
        form.submit();
      });
  });

  /* ------------------------------------------------------------ add to cart */

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    e.preventDefault();

    var button = form.querySelector('button[type="submit"]');
    var label = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return refreshCart();
      })
      .then(function () {
        openDrawer();
        var count = $('[data-cart-count]');
        announce((STRINGS.cartAdded || 'Added to cart. __COUNT__ items in cart.')
          .replace('__COUNT__', count ? count.textContent : ''));
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        if (button) { button.disabled = false; button.textContent = label; }
      });
  });

  /* --------------------------------------------------------- variant picker */

  var dataEl = $('[data-variant-data]');
  if (dataEl) {
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { variants = []; }

    var root = $('[data-product-root]');
    var idInput = $('[data-variant-id]');
    var priceEl = $('[data-price]');
    var addButton = $('[data-add-button]');
    var gallery = $('[data-product-gallery]');

    // Media ids that belong to a specific variant. Anything NOT in this set is a
    // shared shot (detail, flat lay) and stays visible whatever colour is picked.
    var assignedMedia = {};
    variants.forEach(function (v) {
      if (v.media_id) assignedMedia[v.media_id] = true;
    });

    function showMediaFor(variant) {
      if (!gallery) return;
      var target = variant && variant.media_id;

      $$('[data-media-id]', gallery).forEach(function (el) {
        var id = parseInt(el.dataset.mediaId, 10);
        // Unassigned media always shows. Assigned media shows only when it's the
        // selected variant's. With no target, fall back to showing everything
        // rather than an empty gallery.
        el.hidden = assignedMedia[id] && target ? id !== target : false;
      });
    }

    var update = function () {
      var chosen = $$('input[data-option-index]:checked', root).map(function (i) { return i.value; });

      // Reflect the choice in each group's label
      $$('input[data-option-index]:checked', root).forEach(function (input) {
        var label = $('[data-option-label="' + input.dataset.optionIndex + '"]', root);
        if (label) label.textContent = input.value;
      });

      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });

      // Mark combinations that don't exist or are out of stock
      $$('input[data-option-index]', root).forEach(function (input) {
        var trial = chosen.slice();
        trial[parseInt(input.dataset.optionIndex, 10)] = input.value;
        var candidate = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === trial[i]; });
        });
        var lbl = root.querySelector('label[for="' + input.id + '"]');
        if (lbl) lbl.classList.toggle('variant-option--unavailable', !candidate || !candidate.available);
      });

      if (idInput) idInput.value = match ? match.id : '';

      if (priceEl && match) {
        priceEl.innerHTML = match.on_sale
          ? '<span>' + match.price + '</span><del>' + match.compare_at_price + '</del>'
          : '<span>' + match.price + '</span>';
      }

      if (addButton) {
        var ok = match && match.available;
        addButton.disabled = !ok;
        addButton.textContent = ok ? 'Add to cart' : (match ? 'Sold out' : 'Unavailable');
      }

      showMediaFor(match);

      // Keep the URL shareable without reloading
      if (match && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      }
    };

    document.addEventListener('change', function (e) {
      if (e.target.matches('input[data-option-index]')) update();
    });

    update();
  }

  /* ---------------------------------------------------- predictive search */

  // Follows the W3C combobox/listbox pattern: this owns the input, the
  // aria-expanded/aria-activedescendant state and keyboard handling; the
  // predictive-search section owns the listbox markup. Without JavaScript the
  // form simply submits to /search, which works exactly as before.
  $$('[data-psearch]').forEach(function (root) {
    var input   = $('[data-psearch-input]', root);
    var results = $('[data-psearch-results]', root);
    var status  = $('[data-psearch-status]', root);
    if (!input || !results) return;

    var MIN_CHARS = 2;
    var DEBOUNCE = 250;
    var timer = null;
    var controller = null;
    var active = -1;

    function options() {
      return $$('.psearch__item', results);
    }

    function clearResults() {
      results.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      active = -1;
    }

    function highlight(next) {
      var items = options();
      if (!items.length) return;

      // Wrap around at both ends — arrowing past the last result returns to the
      // first, which is what the listbox pattern expects.
      if (next < 0) next = items.length - 1;
      if (next >= items.length) next = 0;

      items.forEach(function (el, i) {
        el.setAttribute('aria-selected', i === next ? 'true' : 'false');
      });

      active = next;
      input.setAttribute('aria-activedescendant', items[next].id);
      items[next].scrollIntoView({ block: 'nearest' });
    }

    function search(term) {
      // Abort a request still in flight so a slow early response cannot
      // overwrite the results for what was typed later.
      if (controller) controller.abort();
      controller = new AbortController();

      var url = '/search/suggest' +
                '?q=' + encodeURIComponent(term) +
                '&resources[type]=product,page' +
                '&resources[limit]=6' +
                '&section_id=predictive-search';

      fetch(url, { signal: controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var section = parsed.querySelector('.shopify-section') || parsed.body;
          results.innerHTML = section.innerHTML;

          var found = options().length;
          input.setAttribute('aria-expanded', found > 0 ? 'true' : 'false');
          active = -1;
          input.removeAttribute('aria-activedescendant');

          if (status) {
            var count = $('[data-psearch-count]', results);
            status.textContent = count
              ? (STRINGS.searchResults || '__COUNT__ results available')
                  .replace('__COUNT__', count.textContent)
              : '';
          }
        })
        .catch(function (err) {
          if (err && err.name !== 'AbortError') clearResults();
        });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      clearTimeout(timer);

      if (term.length < MIN_CHARS) {
        clearResults();
        return;
      }
      timer = setTimeout(function () { search(term); }, DEBOUNCE);
    });

    input.addEventListener('keydown', function (e) {
      var items = options();

      if (e.key === 'ArrowDown') {
        if (!items.length) return;
        e.preventDefault();
        highlight(active + 1);
      } else if (e.key === 'ArrowUp') {
        if (!items.length) return;
        e.preventDefault();
        highlight(active - 1);
      } else if (e.key === 'Enter') {
        // Only intercept when a result is highlighted; otherwise let the form
        // submit to the full results page.
        if (active > -1 && items[active]) {
          var link = items[active].querySelector('a');
          if (link) { e.preventDefault(); window.location.href = link.href; }
        }
      } else if (e.key === 'Escape') {
        clearResults();
        if (root.hasAttribute('data-psearch-inline')) return;
        closePanel(root);
      }
    });

    // Pointer hover should track the same state the keyboard uses.
    results.addEventListener('mousemove', function (e) {
      var item = e.target.closest('.psearch__item');
      if (item) highlight(options().indexOf(item));
    });
  });

  function closePanel(panel) {
    panel.hidden = true;
    var opener = $('[data-psearch-open]');
    if (opener && opener.focus) opener.focus();
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-psearch-open]');
    if (open) {
      var panel = $('[data-psearch]:not([data-psearch-inline])');
      if (!panel) return;             // no panel: let the link navigate
      e.preventDefault();
      panel.hidden = false;
      var field = $('[data-psearch-input]', panel);
      if (field) field.focus();
      return;
    }

    if (e.target.closest('[data-psearch-close]')) {
      var p = e.target.closest('[data-psearch]');
      if (p) closePanel(p);
      return;
    }

    // Click outside the panel closes it.
    var openPanel = $('[data-psearch]:not([data-psearch-inline])');
    if (openPanel && !openPanel.hidden && !e.target.closest('[data-psearch]')) {
      openPanel.hidden = true;
    }
  });

  /* ----------------------------------------------------------- size guide */

  // Printify writes its size table into the product description when
  // "Add size table to description" is enabled. Lift that table out into a
  // dialog so the description stays readable. Without JS the table simply
  // renders inline, which still works.
  var description = $('[data-product-description]');
  var guide = $('[data-size-guide]');
  var guideBody = $('[data-size-guide-body]');
  var guideOpen = $('[data-size-guide-open]');

  if (description && guide && guideBody && guideOpen) {
    var table = description.querySelector('table');
    if (table) {
      guideBody.appendChild(table);
      guideOpen.hidden = false;

      guideOpen.addEventListener('click', function () {
        if (typeof guide.showModal === 'function') guide.showModal();
        else guide.setAttribute('open', '');
      });

      var guideClose = $('[data-size-guide-close]');
      if (guideClose) {
        guideClose.addEventListener('click', function () {
          if (typeof guide.close === 'function') guide.close();
          else guide.removeAttribute('open');
        });
      }
    }
  }
})();
